import React from 'react'
import { connect } from 'react-redux'
import {toJS} from '../../../../util/ToJS'
import LoggedInHeader from '../components/LoggedInHeader'
import { withRouter } from 'react-router-dom'

class VisibleLoggedInHeaderComponent extends React.PureComponent {
  render() {
    return <LoggedInHeader {...this.props} />
  }
}

const mapStateToProps = state => ({
  isFetching: state.getIn(['session', 'isFetching']),
  displayName: state.getIn(['session', 'user', 'displayName']),
  pictureUrl: state.getIn(['session', 'user', 'pictureUrl']),
  numSolved: state.getIn(['profile', 'userInfo', 'numSolved']),
  numRevisions: state.getIn(['profile', 'userInfo', 'numRevisions'])
})

const VisibleLoggedInHeader = withRouter(
  connect(mapStateToProps)(toJS(VisibleLoggedInHeaderComponent))
)

export default VisibleLoggedInHeader



// WEBPACK FOOTER //
// ./src/domains/home/logged-in-home/containers/VisibleLoggedInHeader.js